import { render, staticRenderFns } from "./IconSafeSecure.vue?vue&type=template&id=4931e0e7&"
import script from "./IconSafeSecure.vue?vue&type=script&lang=js&"
export * from "./IconSafeSecure.vue?vue&type=script&lang=js&"
import style0 from "./IconSafeSecure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports